<div>
  <ng-container style="margin: 70px 0px">
    <div
      *ngIf="
        spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0 &&
        getReturnLength(spiderChartItemsData?.scenarioListForAnnumImpact[0].indicators) > 0
      "
      class="setMargin"
    >
      <!-- Chart -->
      <div class="contentMiniClass chartDesign">
        <div class="chart-div d-flex justify-content-center align-items-center">
          <div class="w-100 text-center" style="height: 550px">
            <piqet-angular-radar-chart
              [spiderChartData]="componentItemsArray"
              [chartOpacity]="chartOpacity"
            ></piqet-angular-radar-chart>
          </div>
        </div>
      </div>
      <p class="figureIdClass uniqFigureSeq content-name-subtitle">
        Figure #1: The proportional difference in impact between each package
      </p>
    </div>
  </ng-container>
</div>

<div *ngIf="!!spiderChartItemsData?.projectInterpretation && isFullReport == false">
  <div class="sub-title-class">{{ reportResource.lblInterpretation }}</div>
  <div [innerHTML]="interpretedText" class="common-font"></div>
</div>

<!-- Summary of results - numbers -->
<div></div>
<div>
  <!-- Title -->
  <div class="row" id="summaryResultNo">
    <div class="lblSummaryResultNo">{{ reportResource.lblSummaryResultNo }}</div>
  </div>

  <!-- Table & Table title -->
  <div>
    <div>
      <p class="lblCompareScenarioPackage">{{ reportResource.lblCompareScenarioPackage }}</p>
    </div>

    <div class="row table-div" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length > 0">
      <div class="tableHeading">
        <div class="titleCase uniqTableSeq">
          Table #1: {{ reportResource.lblLifeCycleImpact }} -
          {{ spiderChartItemsData?.functionalUnitName | lowercase }}
        </div>
      </div>
      <div *ngIf="spiderChartItemsData?.isExport" class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td>{{ reportResource.lblImageCategory }}</td>
              <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                {{ item?.scenarioname }}
              </td>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let p of getRange(
                  spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators?.split(';')
                    ?.length
                )
              "
            >
              <td>
                <div class="rowImageAndValueSet">
                  <div><img width="40" height="40" [src]="imagelist[p]" /></div>
                  <br />
                  <div class="rowTextCss">
                    <span style="padding-right: 15px; display: block">{{
                      indicatornamelist[p]
                    }}</span>
                    <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                      indicatorunitnamelist[p]
                    }}</span>
                  </div>
                </div>
              </td>
              <td *ngFor="let data of spiderChartItemsData?.scenarioListForAnnumImpact">
                {{ data?.totals?.split(';')[p] | decimalFormatPipe }}
              </td>
            </tr>
          </tbody>

          <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
            <tr
              *ngFor="let p of getRange(spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length);">
              <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
            <tr>
              <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No
                record is available
              </td>
            </tr>
          </tbody> -->
        </table>
      </div>
    </div>
    <div class="row table-div" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length > 0">
      <div *ngIf="!spiderChartItemsData?.isExport" class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td>{{ reportResource.lblImageCategory }}</td>
              <td *ngFor="let item of spiderChartItemsData?.scenarioListForAnnumImpact">
                {{ item?.scenarioname }}
              </td>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let p of getRange(
                  spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators?.split(';')
                    ?.length
                )
              "
            >
              <td>
                <div class="rowImageAndValueSet">
                  <div><img width="40" height="40" [src]="imagelist[p]" /></div>
                  <br />
                  <div class="rowTextCss">
                    <span style="padding-right: 15px; display: block">{{
                      indicatornamelist[p]
                    }}</span>
                    <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                      indicatorunitnamelist[p]
                    }}</span>
                  </div>
                </div>
              </td>
              <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                {{ data?.totals?.split(';')[p] | decimalFormatPipe }}
              </td>
            </tr>
          </tbody>

          <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
            <tr
              *ngFor="let p of getRange(spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length);">
              <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
            <tr>
              <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No
                record is available
              </td>
            </tr>
          </tbody> -->
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Equivalency Unit -->
<ng-container *ngIf="!!spiderChartItemsData?.additionalElements">
  <div
    class="row table-div"
    *ngIf="spiderChartItemsData?.additionalElements?.toLowerCase().includes('4')"
  >
    <br />
    <div>
      <piqet-angular-organiaztion-equivalancy-unit
        [spiderChartItemsData]="spiderChartItemsData"
      ></piqet-angular-organiaztion-equivalancy-unit>
    </div>
  </div>
</ng-container>
<br />

<div class="row table-div" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
  <div class="tableHeading">
    <div class="uniqTableSeq">
      Table #1: {{ reportResource.lblLifeCycleImpactScenario }}
      -
      {{ spiderChartItemsData?.functionalUnitName | lowercase }}
    </div>
  </div>
  <div *ngIf="spiderChartItemsData?.isExport; else other_checked" class="table-content">
    <div class="row">
      <div class="col12">
        <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
        <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
      </div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td>{{ reportResource.lblCategory }}</td>
            <td *ngFor="let item of spiderChartItemsData?.scenarioListForAnnumImpact">
              {{ item?.scenarioname }}
            </td>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let p of getRange(
                spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators?.split(';')?.length
              )
            "
          >
            <td>
              <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
              <span class="verticalTableHeader" style="margin-top: 1px !important"
                >({{ indicatorunitnamelist[p] }})</span
              >
            </td>
            <!-- <td *ngFor="let k of getRange(this.spiderChartItemsData.scenarioListForAnnumImpact[p]?.savingPercentage?.split(';').length)">
              {{spiderChartItemsData.scenarioListForAnnumImpact[p]?.savingPercentage?.split(';')[k]}} %
            </td> -->
            <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
              {{ data?.savingPercentage?.split(';')[p] | decimalFormatPipe }}%
            </td>
          </tr>
        </tbody>

        <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
          <tr
            *ngFor="let p of getRange(spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length);">
            <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
            </td>
          </tr>
        </tbody>

        <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
          <tr>
            <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No
              record is available
            </td>
          </tr>
        </tbody> -->
      </table>
    </div>
  </div>
  <ng-template #other_checked class="table-content">
    <ng-container *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length > 0">
      <div class="row lowerAndHigher">
        <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
        <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td>{{ reportResource.lblCategory }}</td>
              <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                {{ item?.scenarioname }}
              </td>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let p of getRange(
                  spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length
                )
              "
            >
              <td>
                <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
                <span class="verticalTableHeader" style="margin-top: 1px !important"
                  >({{ indicatorunitnamelist[p] }})</span
                >
              </td>
              <!-- <td *ngFor="let k of getRange(this.spiderChartItemsData.scenarioListForAnnumImpact[p]?.savingPercentage?.split(';').length)">
                        {{spiderChartItemsData.scenarioListForAnnumImpact[p]?.savingPercentage?.split(';')[k]}} %
                      </td> -->
              <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                {{ data.savingPercentage?.split(';')[p] | decimalFormatPipe }} %
              </td>
            </tr>
          </tbody>

          <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
                    <tr
                      *ngFor="let p of getRange(spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length);">
                      <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
                    <tr>
                      <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No
                        record is available
                      </td>
                    </tr>
                  </tbody> -->
        </table>
      </div>
    </ng-container>
  </ng-template>
</div>
<br />
<div class="row table-div" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
  <div class="page-break"></div>
  <div class="tableHeading">
    <div class="uniqTableSeq">Table #1: {{ reportResource.lblLifeCycleImpactAnnum }}</div>
  </div>
  <div
    *ngIf="spiderChartItemsData?.isExport; else other_checked_lblLifeCycleImpactScenario"
    class="table-content"
  >
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblCategory }} (Indicator)</td>
          <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
            {{ item?.scenarioname }}
          </td>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let p of spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';');
            let i = index
          "
        >
          <td>
            <span class="verticalTableHeader" style="margin-top: 1px !important"
              >{{ p }} ({{ indicatorunitnamelist[i] }})</span
            >
          </td>
          <td *ngFor="let item of spiderChartItemsData?.scenarioListForAnnumImpact; let k = index">
            {{
              getMulti(
                spiderChartItemsData.scenarioListForAnnumImpact[k]?.totals?.split(';')[i],
                spiderChartItemsData.scenarioListForAnnumImpact[k]?.numberofUnits
              ) | decimalFormatPipe
            }}
          </td>
        </tr>
      </tbody>

      <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
        <tr>
          <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
        <tr>
          <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No record
            is available
          </td>
        </tr>
      </tbody> -->
    </table>
  </div>
  <ng-template #other_checked_lblLifeCycleImpactScenario class="table-content">
    <div class="table-content" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length > 0">
      <table class="table">
        <thead>
          <tr>
            <td>{{ reportResource.lblCategory }} (Indicator)</td>
            <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
              {{ item?.scenarioname }}
            </td>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let p of spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';');
              let i = index
            "
          >
            <td>
              <span class="verticalTableHeader" style="margin-top: 1px !important"
                >{{ p }} ({{ indicatorunitnamelist[i] }})</span
              >
            </td>
            <td
              *ngFor="let item of spiderChartItemsData?.scenarioListForAnnumImpact; let k = index"
            >
              {{
                getMulti(
                  spiderChartItemsData.scenarioListForAnnumImpact[k]?.totals?.split(';')[i],
                  spiderChartItemsData.scenarioListForAnnumImpact[k]?.numberofUnits
                ) | decimalFormatPipe
              }}
            </td>
          </tr>
        </tbody>

        <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
          <tr
            *ngFor="let p of getRange(spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length);">
            <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1">
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length == 0">
          <tr>
            <td class="lblNoData" [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 1"> No
              record is available
            </td>
          </tr>
        </tbody> -->
      </table>
    </div>
  </ng-template>
</div>
